import type { State } from '../../state/types.tsx';

export const mapStateToProps = (state: State) => ({
	userIsOnboarded: state.domain.userIsOnboarded,
});
